import { render, staticRenderFns } from "./CheckButton.vue?vue&type=template&id=ec12e966&"
import script from "./CheckButton.vue?vue&type=script&lang=js&"
export * from "./CheckButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports